import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { map, Observable } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { CmsCollection, CmsTaxonomyGeneral } from '@fcom/core-api';

@Component({
  selector: 'cms-accordion',
  templateUrl: './cms-accordion.component.html',
  styleUrls: ['cms-accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CmsAccordionComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);

  @Input()
  content$: Observable<CmsCollection>;

  mappedContent$: Observable<CmsCollection>;

  routeFragment: string;

  @Input()
  withPictures = false;

  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly TAXONOMY: typeof CmsTaxonomyGeneral = CmsTaxonomyGeneral;

  ngOnInit(): void {
    this.routeFragment = this.activatedRoute.snapshot.fragment;
    /**
     * Avoid accordion items printing the title twice.
     */
    this.mappedContent$ = this.content$.pipe(
      map((content) => ({
        ...content,
        items: content.items.map((item) => ({
          ...item,
          subjectTaxonomyTags: (item.subjectTaxonomyTags || []).concat([CmsTaxonomyGeneral.NO_TITLE]),
        })),
      }))
    );
  }
}
